module.exports = __webpack_public_path__ + "img/active1.4b522d89.png";